import type { FC } from "react";

import { DynamicPropertyGroupsSearchForm } from "src/app/features/DynamicPropertyGroup/components/forms/DynamicPropertyGroupsSearchForm";
import type { DynamicPropertyGroupEntity } from "src/app/features/DynamicPropertyGroup/types/DynamicPropertyGroupEntity";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";
import { DynamicPropertyGroupsTable } from "../components/tables/DynamicPropertyGroupsTable";

export const DynamicPropertyGroupsPage: FC<NoneOwnProps> = () => {
    const table = <DynamicPropertyGroupsTable />;
    const searchForm = <DynamicPropertyGroupsSearchForm />;
    const hasAccess = canAccess(ResourceName.DYNAMIC_PROPERTY_GROUPS, "canRead");

    return (
        <PageLayout name="dynamicPropertyGroups_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.dynamicPropertyGroups" />
                    <ResourceManager<DynamicPropertyGroupEntity>
                        useDataGroup
                        dataMapperKey="dynamicPropertyGroupsTableData"
                        resource={ResourceName.DYNAMIC_PROPERTY_GROUPS}
                        table={table}
                        actions={[Actions.ADD, Actions.DELETE, Actions.COPY, Actions.EXPORT]}
                        searchForm={searchForm}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
